import axios from "axios";

export async function exportUserActivity(email, startDate = null, endDate = null) {
  const params = { email };
  
  if (startDate) {
    params.start_date = startDate;
  }
  
  if (endDate) {
    params.end_date = endDate;
  }
  
  return await axios
    .get(`/admin/user-activity/export`, {
      params,
      responseType: "blob", // Important for CSV download
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response?.data || error;
    });
}

